export enum InvoiceStatus {
  CREDITED = 'CREDITED',
  OPEN = 'OPEN',
  PAID = 'PAID',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_INITIATED = 'PAYMENT_INITIATED',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  READY_FOR_CHARGE = 'READY_FOR_CHARGE',
  READY_FOR_CHARGE_CONVERSION = 'READY_FOR_CHARGE_CONVERSION',
  WRITTEN_OFF = 'WRITE_OFF',
}

export const UNSUPPORTED_INVOICE_REPORT_STATUSES: InvoiceStatus[] = [
  InvoiceStatus.OPEN,
  InvoiceStatus.WRITTEN_OFF,
  InvoiceStatus.READY_FOR_CHARGE_CONVERSION,
];
